import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { SecurityContextService } from '@services/security_context.service';
import $ from 'jquery';

@Component({
  selector: 'header',
  imports: [CommonModule],
  templateUrl: './header.component.html',
  styleUrl: './header.component.less',
})
export class HeaderComponent {
  // Constants
  user: any = undefined;

  constructor(private _securityContextService: SecurityContextService) {}

  // Lifecycle Hooks
  ngOnInit(): void {
    this.user = this._securityContextService.authData();
  }

  // Functions
  logout = () => {
    this._securityContextService.logOut();
  };

  isFranchise = (franchise: string) => {
    if (this._securityContextService.authData().franchisecode != null) {
      return this._securityContextService.authData().franchisecode == franchise;
    } else {
      return false;
    }
  };

  minimize = () => {
    // JQuery :(
    if (($(window)?.width() || 0) < 769) {
      $('body').toggleClass('show-sidebar');
    } else {
      $('body').toggleClass('hide-sidebar');
    }
  };
}
